module.exports = __webpack_public_path__ + "img/account_issues.edc2f8af.png";